import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslations } from 'use-intl';
import { useBrand } from '@/features/branding/brand-provider';
import { LanguageSelector } from '@/features/locale/components/language-selector';

// Two-column login shell shared by the trainee code login and the admin
// magic-link login. Ports app/[brand]/login/layout.tsx.
export function LoginLayout({ children }: { children: ReactNode }) {
  const { brand: site } = useBrand();
  const t = useTranslations('global');

  return (
    <div className="h-dvh w-full lg:grid lg:grid-cols-2">
      <div className="flex h-full flex-col items-center justify-between py-12">
        <div />
        <div className="mx-auto grid w-[350px] gap-6">
          <div className="text-center">
            <img
              src={site.logo}
              className="m-auto mb-8 max-h-24 min-h-12 max-w-48 min-w-12"
              alt={`${site.name} Logotype`}
            />
            <h1 className="text-3xl font-semibold">{site.name}</h1>
          </div>
          {children}
        </div>
        <div className="mx-auto flex flex-col items-center gap-4">
          <LanguageSelector />
          <div>
            {'E-learning solution by '}
            <a href="https://safeassetgroup.com">SAFE Asset Group</a>
            {' on behalf of '}
            {site.name}
          </div>
          <div className="text-muted-foreground flex flex-row justify-center gap-6 text-sm">
            <Link to={`/${site.slug}/terms-of-service`}>
              {t('terms-of-service')}
            </Link>
            <Link to={`/${site.slug}/gdpr`}>{t('gdpr-policy')}</Link>
            <Link to={`/${site.slug}/privacy-policy`}>
              {t('privacy-policy')}
            </Link>
          </div>
        </div>
      </div>
      <div className="bg-muted hidden overflow-hidden lg:block">
        {site.poster && (
          <img
            src={site.poster}
            alt=""
            className="h-full w-full object-cover dark:brightness-[0.2] dark:grayscale"
          />
        )}
      </div>
    </div>
  );
}
